module.exports = __webpack_public_path__ + "img/gala-feedback.830ae541.svg";